import { render, staticRenderFns } from "./Comitente.vue?vue&type=template&id=b1459e4c"
import script from "./Comitente.vue?vue&type=script&lang=js"
export * from "./Comitente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports